module.exports = __webpack_public_path__ + "img/aviso.75cccf8e.jpg";